import APIClient from '@/shared/http/clients/api'

const resourceName = 'REComunicado'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/?limit=${limit}&index=${index}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/valor/${id}`, config)
const GetAnnouncementsByFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtro/?limit=${limit}&index=${index}`, data, config)
const GetSearchEmpreendimento = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/search`, data, config)
const DownloadPDF = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/comunicados/download/${id}`, data, config)
const GetComunicadoByName = (nome, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/getByName/${nome}`, config)
const GetAllEnterpriseNotCom = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/search`, data, config)

const Announcement = {
  GetAll,
  Create,
  Update,
  Delete,
  GetAnnouncementsByFiltro,
  GetSearchEmpreendimento,
  DownloadPDF,
  GetComunicadoByName,
  GetAllEnterpriseNotCom
}

export default Announcement



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/announcementRepository.js